<template>
  <MTooltip placement="top">
    <template v-slot:trigger>
      <a href="javascript:;" v-on="$listeners">
        <MIcon name="window-maximize" />
      </a>
    </template>
    {{ $t('expand') }}
  </MTooltip>
</template>

<script>
export default {
  name: 'ControlExpandButton',
}
</script>
